import styled from 'styled-components';
import C from '@assets/themes/colors';

interface IProps {
  backgroundValue?: string;
  backgroundColorValue?: string;
  leftValue?: string;
  opacityValue?: string;
  borderColorValue?: string;
  cursorValue?: string;
}

export const Root = styled.div`
  padding: 0px 6px;
`

export const GradientContainer = styled.div`
  padding: 0px 9px;
`

export const Gradient = styled.div`
  height: 25px;
  border-radius: 5px;
  background: ${(props: IProps) => (props.backgroundValue ?? 'auto')};
  background-color: ${(props: IProps) => (props.backgroundColorValue ?? 'auto')};
  cursor: copy;
`

export const ColorStopsContainer = styled.div`
  height: 35px;
  position: relative;
  cursor: ${(props: IProps) => (props.cursorValue ?? 'auto')};
`

export const ColorStopContainer = styled.div`
  position: absolute;
  top: 2px;
  left: ${(props: IProps) => (props.leftValue ?? 'auto')};
  cursor: ${(props: IProps) => (props.cursorValue ?? 'auto')};
`

export const ColorStop = styled.div`
  position: absolute;
  top: 6px;
  left: 2px;
  width: 14px;
  height: 13px;
  border-radius: 2px;
  opacity: ${(props: IProps) => (props.opacityValue ?? 'auto')};
  background-color: ${(props: IProps) => (props.backgroundColorValue ?? 'auto')};
`